import React from 'react';
import Header from '../components/Header';
import Hero from '../components/sections/Hero';
import About from '../components/sections/About';
import HowWeDoIt from '../components/sections/HowWeDoIt';
import WhyChooseUs from '../components/sections/WhyChooseUs';
import Contact from '../components/sections/Contact';
import Footer from '../components/Footer';

const Home = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <Hero />
        <About />
        <HowWeDoIt />
        <WhyChooseUs />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

export default Home;